// extracted by mini-css-extract-plugin
export default {"Nav":"LoginNav_Nav__504rH","Logo":"LoginNav_Logo__OZBvk","Navflex":"LoginNav_Navflex__9zOlS","signUp":"LoginNav_signUp__Thnyn","navW":"LoginNav_navW__870tc"};